<template>
  <b-modal
      modal-class="footer-dialog"
      data-test-path="dialog-select-in-combo"
      id="bv-modal-select-combo"
      :title="title"
      @hide="onHide"
      @ok="onOk"
      ref="modal"
  >
    <b-container class="px-3 mx-0" fluid="true">
      <b-row>
        <b-col class="p-3">
          <b-form-select v-model="selectedRow" :options="lists"></b-form-select>

        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer="{close}">
        <FooterNavbar data-test-path="select-in-data-grid-footer" class="w-100 m-0">
          <CloseButton @close="cancel"></CloseButton>
          <FooterButton type="Ok" :disabled="!selectedRow" @ok="onOk"></FooterButton>
        </FooterNavbar>
    </template>
  </b-modal>
</template>

<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";

export default {
  name: "SelectInComboDialog",
  components: {FooterButton, VBox, FooterNavbar, CloseButton},

  created(){
    /** @type {Function} */
    this.dataLoad = null;
    /** @type {Function} */
    this.refreshDataLoad = null;
  },

  async beforeMount() {
    await this.refresh();
  },

  mounted() {
    /** @type {DataGrid2|Vue} */
    this.grid = this.$refs["grid"];
  },

  methods: {

    dblClickedEditUser(item){
    },

    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
    },

    async onOk() {
      if(this.resolve != null){
        this.resolve(this.selectedRow);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    async cancel() {
      this.$refs.modal.hide();
    },

    async refresh() {
      if(this.dataLoad){
        this.lists = await this.dataLoad();
      }
      if(this.refreshDataLoad){
        this.lists = await this.refreshDataLoad();
      }
    },

    reset(){
      this.result = null;
      this.resolve = null;
    },

    selectFirst(){
      if(this.lists && this.lists.length) {
        this.selectedRow = this.lists[0].value;
      }
    }

  },
  data: () => ({
    lists: [],

    title: "",
    resolve: null,
    result: null,
    selectedRow: null,
  })
}
</script>
